angular.module('picmonic-common').directive('referralBlock', [
  function () {
    return {
      restrict: 'E',
      scope: {
        marketSlug: '=',
      },
      templateUrl: '/templates/directives/referral-block.html',
      controller: [
        '$rootScope',
        '$scope',
        '$cookies',
        '$state',
        '$stateParams',
        'UserService',
        'ReferralResource',
        'ReferralDataService',
        'PromoCodesResource',
        'SplitTestService',
        function (
          $rootScope,
          $scope,
          $cookies,
          $state,
          $stateParams,
          UserService,
          ReferralResource,
          ReferralDataService,
          PromoCodesResource,
          SplitTestService
        ) {
          $scope.base_asset_url = $rootScope.base_asset_url;
          $scope.ReferralDataService = ReferralDataService;
          $scope.is_group_buy = $stateParams.is_group_buy;
          $scope.UserService = UserService;
          $scope.$state = $state;
          $scope.is_redeem = $state.current.name === 'app.redeem';

          if ($stateParams.promo_code) {
            $scope.promo_code = PromoCodesResource.check_expiration({
              promo_code: $stateParams.promo_code,
            });
          }

          //if (!UserService.checkForReferral() && ((UserService.user.user_id && UserService.user.is_trial) || !UserService.user.is_trial)) {
          //    $scope.showSchoolsClosedBanner = SplitTestService.split('schools_closed_banner_v4', ['a', 'b'], null, true);
          //}

          var referrerLinkClicked = $cookies.get('pls_user_referrer_link_clicked');
          if (referrerLinkClicked) {
            $cookies.remove('pls_user_referrer_link_clicked');
            if (typeof atlasEvent !== 'undefined') {
              atlasEvent('referral', referrerLinkClicked);
            }
          }
        },
      ],
    };
  },
]);
